export default function tabsManager(defaultValue, pushUrl = true) {
    return {
        tab: defaultValue,

        init() {
            const urlParams = new URLSearchParams(window.location.search);
            const savedTab = urlParams.get("tab");

            if (savedTab) {
                this.tab = savedTab;
            }

            document.body.addEventListener("htmx:load", () => {
                this.setTab(this.tab, true)
            }, {once: true});

            document.addEventListener("tab:refresh", () => {
                this.refreshTab();
            });
        },

        refreshTab() {
            this.loadTab(this.tab);
        },

        setTab(tabValue, load = false) {
            this.tab = tabValue;
            this.updateUrl(tabValue);

            if (load)
                this.loadTab(this.tab);
        },

        updateUrl(tabValue) {
            if (pushUrl) {
                const url = new URL(window.location);
                url.searchParams.set("tab", tabValue);
                window.history.replaceState({}, "", url);
            }
        },

        loadTab(tabValue) {
            const button = document.querySelector(`[data-tab="${tabValue}"]`);
            if (button) {
                button.click();
            }
        }
    };
}
